export class QueryWhEventStatusRequest {
  facility: string = '';
  hawb: string = '';
  adNo: string = '';
  whNo: string = '';
}
